module.exports = __webpack_public_path__ + "img/【高权重】搜索卡首屏新.d34ca56c.jpeg";